import React from "react";
import { Milestone } from "lucide-react";
import { Link } from "react-router-dom";
import EpqMilestones from "./EpqMilestones";

export default function SubjectCard({ subject, index = 0, minutesLogged = 0 }) {
  const target = subject.weekly_hour_target;
  const isMilestone = subject.is_milestone_based;
  const loggedHours = minutesLogged / 60;
  const pct = target ? Math.min(100, Math.round((minutesLogged / (target * 60)) * 100)) : 0;
  const loggedLabel = Number.isInteger(loggedHours) ? `${loggedHours}h` : `${loggedHours.toFixed(2).replace(/\.?0+$/, "")}h`;

  return (
    <article
      className={`card-soft p-6 sm:p-7 fade-up delay-${Math.min(index + 1, 4)} transition-transform`}
      data-testid={`subject-card-${subject.name.toLowerCase()}`}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-3px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span
            className="inline-block w-3.5 h-3.5 rounded-full"
            style={{ background: subject.color, boxShadow: `0 0 0 4px ${subject.color}25` }}
          />
          <h3 className="font-display text-2xl sm:text-3xl leading-tight" style={{ color: "var(--text)" }}>
            {subject.name}
          </h3>
        </div>
        {isMilestone && (
          <span
            className="text-[11px] uppercase tracking-wider px-2 py-1 rounded-full flex items-center gap-1"
            style={{ background: "var(--surface-2)", color: "var(--accent)", border: "1px solid var(--border)" }}
            data-testid="milestone-badge"
          >
            <Milestone size={12} strokeWidth={1.5} /> milestone
          </span>
        )}
      </div>

      {isMilestone ? (
        <EpqMilestones compact />
      ) : (
        <div className="mt-6">
          <div className="flex items-baseline justify-between">
            <div>
              <span className="font-display text-3xl" style={{ color: "var(--text)" }} data-testid={`subject-hours-${subject.name.toLowerCase()}`}>
                {loggedLabel}
              </span>
              <span className="font-body text-sm text-muted"> / {target}h this week</span>
            </div>
            <span className="font-hand text-base" style={{ color: "var(--accent)" }}>
              {minutesLogged >= target * 60 ? "beautiful" : minutesLogged > 0 ? "keep going" : "let's begin"}
            </span>
          </div>
          <div className="progress-track mt-3" aria-label={`${loggedLabel} of ${target} hours logged`}>
            <div className="progress-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
      )}

      <div className="mt-4 flex justify-end">
        <Link
          to="/tasks"
          className="text-xs font-medium"
          style={{ color: "var(--primary)" }}
          data-testid={`subject-tasks-link-${subject.name.toLowerCase()}`}
        >
          {isMilestone ? "manage milestones →" : "tasks →"}
        </Link>
      </div>
    </article>
  );
}
